/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { navigateTo } from '../../navigate-to/index.js';
import { handleAmapApp } from '../web/index.js';
import '../../../tslib.es6-e01eabb2.js';
import '../../../index-e5fa4dec.js';
import '../../extend/index.js';
import '../../env/index.js';
import '../../../index-f24a9ec1.js';
import '../../../index-892d8eee.js';
import '../../extend/register/index.js';
import '../../../bridges/dd/index.js';
import '../../../index-6f6b9acc.js';
import '../../../_commonjsHelpers-56d33373.js';
import '../../../loadscripts-cf212b8d.js';
import '../../../constants-163bd007.js';
import '../../../bridge-adpter-api-0316c034.js';
import '../../../bridges/windvane/index.js';
import '../../../bridges/nebula/index.js';
import '../../../index.es-142c5680.js';
import '../../../bridges/pangu-mini-app/index.js';
import '../../../log-aabf3a34.js';
import '../../navigate-to/cn/index.js';
import '../../../common-42e7d8d8.js';
import '../../../safe-data-66f20265.js';
import '../../navigate-to/cnStation/index.js';
import '../../navigate-to/tb/index.js';
import '../../navigate-to/ali1688/index.js';
import '../../navigate-to/fm/index.js';
import '../../navigate-to/nebula/index.js';
import '../../navigate-to/dingTalk/index.js';
import '../../navigate-to/dingTalkPC/index.js';
import '../../navigate-to/mini/index.js';
import '../../../index-ee2c9aee.js';
import '../../navigate-to/panguMiniApp/index.js';

function openAmapApp(options) {
    var navUrl = handleAmapApp(options);
    navigateTo({
        url: "tp-dd://callApp?url=".concat(encodeURIComponent(navUrl)),
        success: options.success,
        fail: options.fail,
        complete: options.complete,
    });
}

export { openAmapApp as default };
